<template>
	<div>
        <EmailStellar    ref="email_stellar_modal"    :email=email      ></EmailStellar>
        <Email           ref="email_modal"            :email_id=email_id></Email>

        <!-- DESKTOP layout -->
        <div  v-if="$mq !== 'mobile'"  style="padding:5px;">
            <table class="table table-bordered table-condensed"  style="table-layout:fixed;">
                <thead>
                    <tr>
                        <th class="active text-left" style="width: 80px;">
                            <b>Status</b>
                        </th>
                        <th class="active text-left" style="width: 180px;">
                            <b>Date</b>
                        </th>
                        <th class="active text-left" style="width: 200px;">
                            <b>To</b>
                        </th>
                        <th class="active text-left" style="width: 200px;">
                            <b>cc</b>
                        </th>
                        <th class="active text-left">
                            <b>Subject</b>
                        </th>
                    </tr>
                </thead>
                <tbody v-if="show_emails=='loading'"  class="text-center">
                    <tr>
                        <td  colspan=5>
                            &nbsp;<br>
                            <i class="fas fa-circle-notch fa-spin"></i>  Loading data...<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="show_emails=='no data'"  class="text-center">
                    <tr>
                        <td  colspan=5>
                            &nbsp;<br>
                            <b>No Emails</b>  Once you have sent a protected email, it will appear here.<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else  class="text-center">
                    <tr  v-for="(email, index) in emails"  :key="'fo-'+email.id+index"  style="overflow:hidden;">
<!--
    {
        "id": 35,
        "subject": "Test 09",
        "from": "jim.philpot@me.com",
        "to": "jim@mainfunction.co.uk",
        "cc": "Test DMCA Hero",
        "date": "27 Sep 2020, 10:45:09",
        "attachments": 0,
        "files": [],
        "body": "Hi 09.<br>No attach.<br>Please reply to all."
    }
-->                        
                        <td  class="text-left">
                            <div v-if="email.status == 'Complete'"  class="btn-link"  @click="show_email_stellar(email)">{{ email.status }}</div>
                            <div v-else>{{ email.status }}</div>
                        </td>
                        <td  class="text-left">
                            {{ email.date | moment("Do MMM YYYY, HH:mm:ss") }}<br>
                            <small class="text-muted"><timeago :datetime=email.date :auto-update="120"></timeago></small>
                        </td>
                        <td  class="text-left">
                            <small>{{ email.to }}</small>
                        </td>
                        <td  class="text-left">
                            <small>{{ email.cc }}</small>
                        </td>
                        <td  class="text-left">
                            <div class="btn-link"  @click="show_source_email(email.id)">{{ email.subject }}</div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div v-if="1==2">
                <br>
                <i v-if="page_number > 1"          @click="get_users_emails(1)"                          class="fas fa-angle-double-left"></i>&nbsp;&nbsp;
                <i v-if="page_number > 1"          @click="get_users_emails(parseInt(page_number) - 1)"  class="fas fa-angle-left"></i>&nbsp;&nbsp;
                Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                <i v-if="page_number < page_total" @click="get_users_emails(parseInt(page_number) + 1)"  class="fas fa-angle-right"></i>&nbsp;&nbsp;
                <i v-if="page_number < page_total" @click="get_users_emails(page_total)"                 class="fas fa-angle-double-right"></i>
            </div>

            <div  v-if="emails  &&  emails.length > 0"
                  style="width:100%;
                         display:flex; justify-content:end; align-items:center;
                         clear:both;">
                <div style="margin-right:10px;">
                    Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                </div>
                <div style="margin-right:10px;">
                    <button  @click="get_users_emails(parseInt(page_number) - 1)" 
                            :disabled="page_number == 1"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-left"></i>
                    </button>
                </div>
                <div style="margin-right:0px;">
                    <button  @click="get_users_emails(parseInt(page_number) + 1)" 
                            :disabled="page_number == page_total"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>

        <!-- MOBILE layout -->
        <div  v-else                   style="padding:5px;">
            <table class="table table-bordered table-condensed"  style="table-layout:fixed;">
                <thead>
                    <tr>
                        <th class="active text-left" style="width: 80px;">
                            <b>Status</b>
                        </th>
                        <th class="active text-left" style="width:100%;">
                            <b>Subject</b>
                        </th>

                    </tr>
                </thead>
                <tbody v-if="show_emails=='loading'"  class="text-center">
                    <tr>
                        <td  colspan=2>
                            &nbsp;<br>
                            <i class="fas fa-circle-notch fa-spin"></i>  Loading data...<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else-if="show_emails=='no data'"  class="text-center">
                    <tr>
                        <td  colspan=2>
                            &nbsp;<br>
                            <b>No Emails</b>  Once you have received a protected email, it will appear here.<br>
                            &nbsp;
                        </td>
                    </tr>
                </tbody>
                <tbody v-else  class="text-center">
                    <template  v-for="email in emails">
                        <tr :key="email.id">
                            <td  class="text-left" style="padding-bottom:1px !important; border-bottom:none !important;border-right:none !important;">
                                <small v-if="email.status == 'Complete'"  class="btn-link"  @click="show_email_stellar(email)">{{ email.status }}</small>
                                <small v-else>{{ email.status }}</small>
                            </td>
                            <td  class="text-left" style="padding-bottom:1px !important; border-bottom:none !important; border-left:none !important;">
                                <div class="btn-link"  @click="show_source_email(email.id)"><small>{{ email.subject }}</small></div>
                            </td>
                        </tr>
                        <tr>
                            <td  class="text-right"  style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;">
                                <small><b>Date:</b></small>
                            </td>
                            <td  class="text-left"    style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;" colspan=2>
                                <small>{{ email.date | moment("Do MMM YYYY, HH:mm:ss") }} <small class="text-muted"><timeago :datetime=email.date :auto-update="120"></timeago></small></small>
                            </td>
                        </tr>
                        <tr>
                            <td  class="text-right" style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;">
                                <small><b>To:</b></small>
                            </td>
                            <td  class="text-left"  style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;" colspan=2>
                                <small>{{ email.to }}</small>
                            </td>
                        </tr>
                        <tr>
                            <td  class="text-right" style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;">
                                <small><b>cc:</b></small>
                            </td>
                            <td  class="text-left"  style="padding-top:1px !important; padding-bottom:1px !important; border:none !important;" colspan=2>
                                <small>{{ email.cc }}</small>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>

            <div  v-if="emails  &&  emails.length > 0"
                  style="width:100%;
                         display:flex; justify-content:end; align-items:center;
                         clear:both;">
                <div style="margin-right:10px;">
                    Page {{ page_number }} of {{ page_total }}&nbsp;&nbsp;
                </div>
                <div style="margin-right:10px;">
                    <button  @click="get_users_emails(parseInt(page_number) - 1)" 
                            :disabled="page_number == 1"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-left"></i>
                    </button>
                </div>
                <div style="margin-right:0px;">
                    <button  @click="get_users_emails(parseInt(page_number) + 1)" 
                            :disabled="page_number == page_total"
                            name="button"  type="submit"  
                            class="btn btn-small btn-primary"
                    >
                        <i class="fas fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import EventBus      from '@/event_bus';					// Event Bus
    import EmailStellar  from '@/components/modals/email_stellar.vue';
    import Email         from '@/components/modals/email.vue';

    export default {
        components: {
            EventBus,
            EmailStellar,
            Email,
        },

        data() {
            return {
                email_id:      '',
                email:         '',

                explorer_link: '',
				show_emails:   'loading',
                emails:        [],
				page_total:    0,
				page_number:   1,
				page_rows:     12,
            };
        },

        computed: {
        },
		
		created() {
            if (process.env.VUE_APP_ENV != "production") {
                this.explorer_link = 'https://testnet.steexp.com/tx/';
            }
            else {
                this.explorer_link = 'https://steexp.com/tx/';
            }
		},

        mounted() {
			if (this.is_logged_in()) {
				this.get_users_emails(1);
			}
        },
		
        methods: {
			is_logged_in() {
				var status     = false;
				this.api_token = localStorage.getItem('api_token');
				
				if (this.api_token  &&  this.api_token.length == 64) {
					status = true;
				}
					
				return status;
			},

            // Show Stellar Network modal
            show_email_stellar(email) {
                this.email  = email;
                let element = this.$refs.email_stellar_modal.$el;
                $(element).modal('show');
            },
    
            // Show Source Email modal
            show_source_email(email_id) {
                this.email_id = email_id;
                let element   = this.$refs.email_modal.$el;
                $(element).modal('show');
            },
    
            // Get Users Emails
            get_users_emails(page) {
				let vm = this;
				var emails;
				
				vm.show_emails = 'loading';

				// Call API for user's emails
                const axios_config = {
                    headers: {
                        'api-token': this.api_token,
                    },
                    params: {
                        type:        'sent',
                        page_rows:   this.page_rows,
                        page_number: page,
                    }
                };

				this.axios.get('api/emails', axios_config)
				.then(response => {
					vm.emails      = response.data.records;
					vm.page_total  = response.data.pagination.page_total;
					vm.page_number = response.data.pagination.page_number;

					if (vm.emails.length == 0) {
						vm.show_emails = "no data";
					}
					else {
						vm.show_emails = "true";
                    }
                    
                    EventBus.$emit('total_emails_sent', response.data.pagination.total_recs);
                })
				.catch(error => {
					var error_msg = '';
					if (error.response) {
                        if (error.response.data.message) {
                            error_msg = error_msg + error.response.data.message + "<br>";	
                        }
                        
                        if (error.response.data.error) {
                            Object.keys(error.response.data.error).forEach(key => {
                                error_msg = error_msg + error.response.data.error[key] + "<br>";

                                // load api errors into client errors
                                this.errors.add({
                                    field: key,
                                    msg:   error.response.data.error[key],
                                });
                            });
                        }

                        this.$notify({
                            group: "fs_danger",
                            title: "Error",
                            text: error_msg,
                            type: "error"
                        });
                    }
                    else if (error.message == "Network Error") {
                        localStorage.removeItem('api_token');
				        this.$store.commit("RESET");
                        this.api_token = null;

                        this.$notify({
                            group: "fs_warning",
                            title: "Session has expired",
                            text:  "Please log in again.",
                            type:  "error"
                        });

                        EventBus.$emit('refresh_header_api_token', this.api_token);
                        this.$router.push({'name': 'home'});
                    }
                    else {
                        this.$notify({
                            group: "fs_danger",
                            title: "Error",
                            text: "Unexpected error.<br>Suggest logging out and back in again.",
                            type: "error"
                        });
                    }
                });
			},
        }
    };
</script>
